var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-start tw-py-2 tw-px-5 tw-bg-success-50 tw-rounded-xl"},[_c('span',{staticClass:"tw-font-semibold"},[_vm._t("default")],2),(_vm.icon)?_c('UiIcon',{staticClass:"tw-shrink-0 tw-ml-auto tw-h-6 tw-w-6 tw-text-gray-500",attrs:{"name":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }